const fringe = {"showName": "Stop The Press (Edinburgh Fringe 2022)",
    "short": "DramSoc Fringe Production and my first show, making first cues and picking up QLab and a Zero88 desk to run a show.",
    "role": "Show Designer/Operator",
    "tech": "Phantom FLX S24/QLab4",
    "date": "08/22",
    "imageDir": "showImgs/fringe.jpg"
};

const earthquakes = {"showName": "Earthquakes in London",
    "short": "DramSoc Main Show 22/23 at the Bridewell Theatre, where I first picked up EOS, programming the second half of the show.",
    "role": "Assistant LD / Lighting Operator",
    "tech": "EOS",
    "date": "01/23",
    "imageDir": "showImgs/earthquakes.JPG"
};

const addamsFamily = {"showName": "Addams Family",
    "short": "MT Main Show 22/23, ASM'ing and Mic Monkey'ing (Mic Monkey like banana).",
    "role": "Mic Monkey",
    "tech": "Mics and Tape lol",
    "date": "03/23",
    "imageDir": "showImgs/addamsFamily.jpeg"
};

const pillowman = {"showName": "The Pillowman",
    "short": "DramSoc Studio Show Spring 23, a Fringe style production with mirrors in the backwall. Intentionally blinded and deafened the audience.",
    "role": "Show Designer/Operator",
    "tech": "EOS/QLab4",
    "date": "03/23",
    "imageDir": "showImgs/pillowman.JPG"
};

const grinolio = {"showName": "Grinolio's Home",
    "short": "My only acting credit, where I played an Italian chef in a student-written comedy at Dramfest 23.",
    "role": "Super Mario",
    "tech": "I acted (oh no)",
    "date": "06/23",
    "imageDir": "showImgs/grinolio.jpg"
};

const upbeat23 = {"showName": "Upbeat Rocks 23",
    "short": "Light Op for Upbeat Rocks, a performance showcase by a charity teaching children to sing/dance/play instruments (wholesome).",
    "role": "Lighting Operator",
    "tech": "Avo TT2",
    "date": "06/23",
    "imageDir": "showImgs/upbeat.jpg"
};

// Creating Gabriel

const octShow23 = {"showName": "October Show 23",
    "short": "DramSoc/MTSoc Year Opening Double Bill, where I was the sole lighting designer and the first time I called a show.",
    "role": "Lead Lighting Designer / DSM",
    "tech": "EOS",
    "date": "10/23",
    "imageDir": "showImgs/octShow23.JPG"
};

const cgcuDinner23 = {"showName": "CGCU Dinner 23",
    "short": "24h Event Craziness: Pack Equipment Into a Van (@8am Sat) -> Transport to de Vere Connaught Rooms -> Set up AV in the main hall -> Run the Dinner -> Set up the AV at the dancefloor -> Run the Club Section -> Pack up -> Transport -> Pack into Storage (@7am Sun)",
    "role": "Crew",
    "tech": "Avo TT2",
    "date": "10/23",
    "imageDir": "showImgs/cgcuDinner.jpg"
};

const halloweenACC23 = {"showName": "Halloween ACC 23",
    "short": "The nicest of the IC Club nights I was involved in; getting to use Sceptron with P3 was pretty cool. Typical, leaving at 4am before getting back for lectures on campus at 9am the next day!",
    "role": "Crew / Light Op",
    "tech": "Avo TT2",
    "date": "11/23",
    "imageDir": "showImgs/acc23.jpg"
};

const revue23 = {"showName": "Revue 23",
    "short": "Musical Theatre 14 Song Showcase, coaching new lighting designers, programming half the numbers myself and running the show nights.",
    "role": "Lead Lighting Designer / DSM / Production Manager",
    "tech": "EOS",
    "date": "12/23",
    "imageDir": "showImgs/revue23.jpg"
};

const romeoAndJuliet = {"showName": "Romeo and Juliet",
    "short": "DramSoc Main 23/24, leading a team of 5 LDs for idea'ting the show. From compiled ideas, ultimately programmed the show myself and called it.",
    "role": "Lead Lighting Designer / DSM",
    "tech": "EOS",
    "date": "01/24",
    "imageDir": "showImgs/romeoAndJuliet.jpg"
};

const cssa24 = {"showName": "CSSA 2024",
    "short": "CSSA Cultural Society Yearly Show; as PM, I advised CSSA on the appropriate equipment, managed relations on the day and sorted problems on the day so that my crew could focus on delivering their best work.",
    "role": "Production Manager",
    "tech": "",
    "date": "02/24",
    "imageDir": "showImgs/cssa.jpeg"
};

const acapellaCompetition = {"showName": "OAC 2024",
    "short": "Open Acapella Competition, hosted at Imperial in 2024. I was the light op for the day, following the creative vision of the acts, whilst also lighting a beatboxing section and a preview of a Fringe production.",
    "role": "Lighting Operator",
    "tech": "Avo TT2",
    "date": "02/24",
    "imageDir": "showImgs/oac2024.PNG"
};

const springAwakening = {"showName": "Spring Awakening",
    "short": "MTSoc Main 23/24. As PM, I set out the timeline of the production, assembled a crew, organised production meetings, facilitated work between departments, budgeting, publicity etc. I also coached the incoming Lighting Director to LD and DSM the show.",
    "role": "Production Manager / Lighting Designer / Lighting Operator",
    "tech": "EOS/When2Meet frfr",
    "date": "03/24",
    "imageDir": "showImgs/springAwakening.jpeg"
};

const bigFish = {"showName": "Big Fish",
    "short": "MTSoc Studio 23/24, where a week before the opening night I scrambled a bare bones crew to run the show. I sound op'd the cast mics, using the SD9 for the first time whilst dealing with final year viva.",
    "role": "Sound Operator",
    "tech": "SD9",
    "date": "03/24",
    "imageDir": "showImgs/bigFish.jpg"
};

const fashion24 = {"showName": "IC Fashion 2024",
    "short": "Imperial College Fashion Show. Having just finished my exams, I immediately hopped into a get-in and the next light op'd this charity event.",
    "role": "Lighting Operator",
    "tech": "Avo TT2",
    "date": "06/24",
    "imageDir": "showImgs/fashion.jpg"
};

const silfest24 = {"showName": "Silfest 24",
    "short": "Student Music Festival at Imperial's Silwood Park; I designed the lighting rig for the event and light op'd most of the day, coaching a fresher to mash some buttons too.",
    "role": "Lighting Designer",
    "tech": "Avolites TT2",
    "date": "07/24",
    "imageDir": "showImgs/silfest24.JPG"
};

const idea2025 = {"showName": "IDEA 2025",
    "short": "Imperial Dance Showcase, a 35 act show of all different Imperial dance societies of which I programmed 32. My rig consisted of equipment from a hire, work and DramSoc's own stock. It was a privilege to work with the most competent crew I've ever had, where frankly I was the weakest link.",
    "role": "Lighting Designer / Show Operator",
    "tech": "Avolites TT2",
    "date": "03/25",
    "imageDir": "showImgs/idea25.jpg"
};

const crucible = {"showName": "The Crucible",
    "short": "Sedos Show run in September 2025. Worked under a significantly more experienced LD, who helped me make a scene go from looking good to looking great! I ran the show lighting and sound, dealing with practicals on the day. Was stunned at the quality of the performance.",
    "role": "Assistant Lighting Designer / Show Operator",
    "tech": "Ion XE",
    "date": "09/25",
    "imageDir": "showImgs/crucibleLarge.jpg"
};

const allShows = [
    fringe,
    earthquakes,
    addamsFamily,
    pillowman,
    grinolio,
    upbeat23,
    octShow23,
    cgcuDinner23,
    halloweenACC23,
    revue23,
    romeoAndJuliet,
    cssa24,
    acapellaCompetition,
    springAwakening,
    bigFish,
    fashion24,
    silfest24,
    idea2025,
    crucible
]
allShows.reverse();

export {allShows};
